<template>
  <div class="footer">
    <p>@copyright 北京友创时代科技发展有限公司 <a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备15038356号-1</a></p>
    <p style="font-size: 12px">北京市朝阳区朝外大街26号20层A2305内02室 电话:010-59479562</p>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    width: 100%;
    text-align: center;
    line-height: 24px;
    color: #AEAEAE;
    border-top: 1px solid #eeeeee;
    padding: 40px 0;
    a {
      color: rgba(1, 116, 244, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue